import React, { Component } from 'react';
import { Modal, Checkbox, Radio, Button, message, Spin, Icon } from 'antd';
import SearchRetrieve from '../../../common/SearchRetrieve.new.js';
import Fetch from '../../../../common/Fetch';
import API_URL from '../../../../common/url';
import { getMatchOption } from '../../../shared/selectFn.js';

class RegisterTeaching extends Component {
    state = {
        list: [],
        params: {},
        visible: false,
        loading: false,
        saveParams: {},
        noNeedTeacher: false,
    }

    show = (params) => {
        this.setState({
            params,
            visible: true,
            saveParams: {},
            noNeedTeacher: params.noNeedTeacher === '1',
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    loadData = () => {
        const { params: { userId } } = this.state;
        Fetch.post(API_URL.user.queryUserTeacherByUserId, {
            userId
        }).then(res => {
            const { list } = res;
            this.setState({ list });
        }).catch(err => {
            console.error(err);
        });
    }

    handleAdd = () => {
        const { params: { userId }, saveParams: { teacherId }, noNeedTeacher } = this.state;
        if (noNeedTeacher) {
            return;
        }
        if (!teacherId) {
            message.warning('请选择带教老师！');
            return;
        }
        this.setState({ loading: true });
        Fetch.post(API_URL.user.addUserTeacher, {
            userId,
            teacherId,
        }).then(res => {
            message.success(res.success);
            this.setState({
                loading: false,
            }, () => {
                this.handleChange({}, 'teacher');
                this.loadData();
                this.props.loadData();
            });
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        });
    }

    preDelete = (userTeacherId) => {
        const { list } = this.state;
        const { isMain } = getMatchOption(list, 'userTeacherId', userTeacherId);
        if (isMain && list.length > 1) {
            message.warning('请先将主带教老师身份交接给其他人！');
            return;
        }
        this.handleDelete(userTeacherId);
    }

    handleDelete = (userTeacherId) => {
        Modal.confirm({
            title: '确定删除此带教老师？',
            content: '删除此带教老师，将同步删除带教学生所填写的带教质量评估表，上报的带教奖励、出师奖励',
            okText: '确定',
            cancelText: '取消',
            onOk: () => {
                this.setState({ loading: true });
                Fetch.post(API_URL.user.delUserTeacher, {
                    userTeacherId,
                }).then(res => {
                    message.success(res.success);
                    this.setState({ loading: false }, () => {
                        this.loadData();
                        this.props.loadData();
                    });
                }).catch(err => {
                    this.setState({ loading: false });
                    console.error(err);
                });
            },
        });
    }

    setMainTeacher = (params) => {
        const { userId, userTeacherId, teacherWorkStatus } = params;
        if (teacherWorkStatus === 'LEFT') {
            message.warning('离职的带教老师，不可设置变更为主带教老师！');
            return;
        }
        Modal.confirm({
            title: '确定设置该人员为主带教老师？',
            okText: '确定',
            cancelText: '取消',
            onOk: () => {
                Fetch.post(API_URL.user.setMainUserTeacher, {
                    userId,
                    userTeacherId,
                }).then(res => {
                    message.success(res.success);
                    this.setState({ loading: false }, () => {
                        this.loadData();
                        this.props.loadData();
                    });
                }).catch(err => {
                    this.setState({ loading: false });
                    console.error(err);
                });
            },
        });
    }

    handleChange = (value, key) => {
        const { saveParams } = this.state;
        const { value: teacherId, text: teacherName } = value;
        saveParams.teacherId = teacherId;
        saveParams.teacherName = teacherName;
        this.setState({ saveParams });
    }

    handleCheckChange = (e) => {
        const { params: { userId } } = this.state;
        const noNeedTeacher = e.target.checked;
        this.setState({ loading: true });
        Fetch.post(API_URL.teaching.updateNoNeedTeacher, {
            userId,
            noNeedTeacher: noNeedTeacher ? 1 : 0
        }).then(() => {
            this.setState({
                noNeedTeacher,
                loading: false,
            }, () => {
                this.props.loadData();
            });
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        });
    }

    getContent = () => {
        const { list, params, saveParams, noNeedTeacher } = this.state;
        const { userCompellation, employeeCode } = params;
        const { teacherName } = saveParams;
        return (
            <div>
                <li className="modal-item">
                    <div className="item-left" style={{width: 103, paddingRight: 10}}>人员:</div>
                    <div className="item-right">
                        {`${userCompellation}[${employeeCode}]`}
                    </div>
                </li>
                <li className="modal-item" style={{marginBottom: 15}}>
                    <div className="item-left" style={{width: 103, paddingRight: 10}}>带教老师:</div>
                    <div className="item-right">
                        {
                            list.map(i => 
                                <div style={{position: 'relative'}} key={i.userTeacherId}>
                                    <span style={{color: i.teacherWorkStatus === 'LEFT' && '#ccc'}}>{`${i.teacherName}[${i.teacherCode}]`}</span>
                                    <Icon
                                        type="close-circle-o"
                                        onClick={() => this.preDelete(i.userTeacherId)}
                                        style={{position: 'absolute', top: '6px', left: '100px', color: '#F00', fontSize: 16, verticalAlign: 'middle', cursor: 'pointer'}}
                                    />
                                    { list.length > 1 && <Radio checked={i.isMain === 1} style={{position: 'absolute', left: '130px'}} onChange={e => this.setMainTeacher(i)}>主带教老师</Radio> }
                                </div>
                            )
                        }
                    </div>
                </li>
                <li className="modal-item" style={{marginTop: 15, borderTop: '1px solid #d1d1d1'}}>
                    <div className="item-left" style={{width: 103, paddingRight: 10}}>添加带教老师:</div>
                    <div className="item-right">
                        <div>
                            <SearchRetrieve
                                keyword='keyword'
                                style={{ width: 162 }}
                                value={teacherName}
                                disabled={noNeedTeacher}
                                placeholder='输入姓名或工号检索'
                                url={API_URL.investigation.queryUserByKey}
                                params={{ limit: 20, dimissionStatus: 'WORKING'}}
                                config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                                onChange={value =>this.handleChange(value, 'teacher')}
                            />
                            <Icon
                                type="plus-circle-o"
                                onClick={this.handleAdd}
                                style={{marginLeft: 10, color: '#0e77ca', fontSize: 16, verticalAlign: 'middle', cursor: 'pointer'}}
                            />
                        </div>
                        <div style={{ marginTop: 6 }}>
                            <Checkbox
                                disabled={list.length}
                                checked={noNeedTeacher}
                                onChange={this.handleCheckChange}
                            >
                                无需带教老师
                            </Checkbox>
                        </div>
                    </div>
                </li>
            </div>
        );
    }

    render() {
        const { visible, loading } = this.state;
        return (
            <Modal
                title="登记带教老师"
                visible={visible}
                onCancel={this.hide}
                className="setjde-modal addchildcontract"
                wrapClassName="vertical-center-modal"
                confirmLoading={loading}
                maskClosable={false}
                width="420px"
                footer={<Button type="ghost" onClick={this.hide}>关闭</Button>}
            >
                <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: '0 20px' }}>
                        <ul className="modal-list">
                            {this.getContent()}
                        </ul>
                    </div>
                </Spin>
            </Modal>
        );
    }
}

export default RegisterTeaching;


// WEBPACK FOOTER //
// ./src/components/teachingManagement/management/components/RegisterTeaching.js